import { connect } from "react-redux";
import get from "lodash/get";

import {
  getDevices as onGetDevices,
  selectedDevice as onSelectDevice,
  clearDevices as onClearDevices,
  getProtocolMarkers as onGetProtocolMarkers,
  getDevicePatterns as onGetDevicePatterns,
  createDevice as onCreateDevice,
} from "./../../actions/devicesAction";

const mapStateToProps = (state) => ({
  dataStateDevices: state.devices.dataStateDevices,
  dataStateProtocolMarkers: state.devices.dataStateProtocolMarkers,
  devicePatternsDataState: state.devices.devicePatternsDataState,
  createDeviceDataState: state.devices.createDeviceDataState,
  devices: get(state, ["devices", "devices"], []),
  selectedDevice: get(state, ["devices", "selectedDevice"], null),
  protocolMarkers: get(state, ["devices", "protocolMarkers"], null),
  devicePatterns: get(state, ["devices", "devicePatterns"], null),
});

const mapDispatchToProps = { onGetDevices, onSelectDevice, onClearDevices, onGetProtocolMarkers, onGetDevicePatterns, onCreateDevice };

const withDevices = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDevices };
